<template>
    <div class="bg-white h-100 w-100 d-flex flex-column">
        <div class="file-detail-header flex-grow-0 d-flex justify-content-between align-items-center p-3">
            <div class="d-flex align-items-center">
                <file-icon-comp :fileType="file.selected.FileType"></file-icon-comp>
                <div class="file-headers d-flex flex-column">
                    <span class="file-headers__title">{{file.selected.Name}}</span>
                    <span class="file-headers__subtitle">Sent By Example</span>
                </div>
            </div>
            <div class="d-flex flex-column">
                <span class="file-headers__subtitle">
                    <font-awesome-icon :icon="['fad', 'calendar-alt']" fixed-width class="text-primary"></font-awesome-icon>
                    Sent On: <strong>{{dateSent}}</strong>
                </span>
                <span class="file-headers__subtitle">
                    <font-awesome-icon :icon="['fad', 'hdd']" fixed-width class="text-primary"></font-awesome-icon>
                    File Size: <strong>{{file.selected.Size}}K</strong>
                </span>
            </div>
        </div>
        <div class="file-controls d-flex align-items-center justify-content- bg-light">
            <file-control :icon="['fad', 'download']" :text="'download'" :bgClass="'bg-success'" :textClass="'text-white'" :iconClass="'text-white'" @click.native="testDownload"></file-control>
            <file-control :icon="['fad', 'reply']" :text="'reply'"></file-control>
            <file-control :icon="['fad', 'eye']" :text="'mark as read'"></file-control>
            <file-control :icon="['fad', 'archive']" :text="'archive'"></file-control>
            <file-control :icon="['fad', 'trash-alt']" :text="'delete'" :bgClass="'bg-danger'" :textClass="'text-white'" :iconClass="'text-white'"></file-control>
        </div>
        <div class="file-detail-notes flex-grow-1 p-3">
            <p>Dear User,</p>
            <p>Please find attached</p>
        </div>
        <div class="file-detail-download bg-primary w-100" :style="{height: downloadPercent === 0 ? '0' : '2em'}">
            <div class="file-detail-download__progress bg-success h-100" :style="{width: downloadPercent + '%'}">
                <div class="file-detail-download__text d-flex align-items-center justify-content-start w-100">
                    <div class="d-flex justify-content-center w-100">
                        <span>{{downloadPercent}}%</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { mapState } from 'vuex'
import FileIconComp from '../file-elements/file-icon'
import FileControl from '../file-elements/file-control'
import Swal from 'sweetalert2'

export default {
    props: {
        fileId: Number
    },
    data() {
        return {
            downloadPercent: 0,
            timer: null
        }
    },
    components: {
        FileIconComp,
        FileControl
    },
    created() {
        this.$store.dispatch('file/fetchReceivedFile', this.fileId)
    },
    computed: {
        ...mapState(['file', 'selected']),
        dateSent() {
            return (new Date(this.file.selected.DateAdded)).toLocaleString('en-GB')
        }
    },
    destroyed() {
        this.$store.dispatch('file/clearSelectedFile')
    },
    methods: {
        testDownload() {
            console.log('testDownload()')
            if (this.downloadPercent < 100) {
                this.timer = setTimeout(this.incrementPercent, 150)
            } else {
                clearTimeout(this.timer)
                Swal.fire({
                    title: 'Success!',
                    text: 'File downloaded successfully.',
                    icon: 'success',
                    target: this.$el,
                    heightAuto: false
                })
            }
        },
        incrementPercent() {
            console.log('incrementPercent()')
            if (this.downloadPercent < 97) {
                this.downloadPercent = this.downloadPercent + 4
            } else {
                this.downloadPercent = 100
            }
            this.testDownload()
        }
    }
}
</script>
<style scoped>
.file-headers__title {
    font-size: 1em;
    font-weight: 600;
}
.file-headers__subtitle {
    font-size: 0.8em;
    color: #444;
    text-transform: uppercase;
}
.file-detail-header {
    border-top: 1px solid #dee2e6;
    border-bottom: 1px solid #dee2e6;
}
.file-controls {
    border-bottom: 1px solid #dee2e6;
}
.file-detail-download {
    transition: height 0.25s ease;
    position: relative;
}
.file-detail-download__progress {
    transition: width 0.15s ease;
    min-width: 30px;
    width: 73%;
    position: relative;
}
.file-detail-download__text {
    position: absolute;
    left: 0;
    top: 0;
    height: 100%;
    padding: 0.5em;
    font-size: 1em;
    color: white;
    text-transform: uppercase;
}
</style>


// WEBPACK FOOTER //
// src/components/received-files-view/received-files-file.vue